$(function(){
    const $sliderIndicatorOuter = $('.js-slider-indicator__outer');
    const $sliderIndicator = $('.js-slider-indicator');
    const $sliderIndicatorTuhmb = $('.js-slider-indicator-thumb');

    $sliderIndicatorOuter.slick({
        slidesToShow: 1,
        infinite: false,
        arrows: false,
        adaptiveHeight: true,
        touchMove: false,
        dots: true,
    });
    
    $sliderIndicatorOuter.on('init', function() {
        setTimeout(function() {
            $('.js-slider-indicator__outer').addClass('init');
        }, 2000)
    })

    $sliderIndicator.slick({
        slidesToShow: 1,
        infinite: true,
        fade: true,
        arrows: false,
        asNavFor: '.js-slider-indicator-thumb',
        draggable: false,
        swipe: false,
        swipeToSlide: false,
        touchMove: false,
        arrows: false,
    });
    $sliderIndicatorTuhmb.slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        asNavFor: '.js-slider-indicator',
        focusOnSelect: true,
        dots: false,
    });
})